export default (str) => {

  return "<p>"
    + str.replace(/\[upl-image-preview url=(.*)\]/gi, "<img src=$1>")
         .replace(/\[upl-file uuid=(.*) size=(.*)\](.*)\[\/upl-file\]/gi, "<div class=\"ButtonGroup\" data-fof-upload-download-uuid=\"$1\"><div class=\"Button hasIcon Button--icon Button--primary\"><i class=\"fas fa-download\"></i></div><div class=\"Button\">$3</div><div class=\"Button\">$2</div></div>")
         .replace(/\[(.*)\]\((.*)\)/, '<a href="$2" target="_blank">$1</a>').split("\n").join("</p><p>")
        .replace(/[^("=](https?:\/\/[\w\-а-яА-Я-]{1,}.[\wа-яА-Я-]{1,}[\/0-9a-zA-Zа-яА-Я-%.?=\-]{1,})/gu, ' <a href="$1" target="_blank">$1</a> ')
        .replace(/^(https?:\/\/[\w\-а-яА-Я-]{1,}.[\wа-яА-Я-]{1,}[\/0-9a-zA-Zа-яА-Я-%.?=\-]{1,})$/, ' <a href="$1" target="_blank">$1</a> ')
    + "</p>";
}
